export default __webpack_public_path__ + "static/5-highlights-of-best-us-road-trip-according-to-science-e01fcbc775de935369f28442b71a6329.jpg";